module.exports = __webpack_public_path__ + "img/kommune-1421.fd6354bc.svg";